module.exports = __webpack_public_path__ + "b5c4bc23e4c255bf32b371d4cc7a8414.svg";